import classNames from 'classnames';

import {InternalFeedbackBannerWrapper} from '../../internal-feedback/internal-feedback-banner-wrapper';
import {PageContainer} from '../../layout/page-container';

import styles from './core-entity-page-container.module.css';

interface Attribute {
    key: string;
    value: any;
}

type Props = {
    title: string;
    scrollContainerRef?: (el: HTMLDivElement | null) => void;
    children: React.ReactNode;
    id?: string;
    attributes?: Attribute[];
    hasFullHeightSidebar?: boolean;
};

export function CoreEntityPageContainer(props: Props) {
    const {title, scrollContainerRef, children, id, hasFullHeightSidebar} = props;

    const attributes =
        props.attributes?.reduce<Record<string, any>>((acc, attribute) => {
            acc[attribute.key] = attribute.value;

            return acc;
        }, {}) ?? {};

    return (
        <PageContainer title={title} noPadding={true}>
            <InternalFeedbackBannerWrapper />
            <div className={styles['fake-border-radius-container']}>
                <div
                    className={classNames(styles['fake-border-radius'], {
                        [styles['fake-border-radius--dev']]: NutClientConfig.isDevelopment,
                    })}
                />
            </div>
            <div
                id={hasFullHeightSidebar ? undefined : id}
                ref={hasFullHeightSidebar ? undefined : scrollContainerRef}
                className={classNames(styles.container, {
                    [styles['container--full-height-sidebar']]: hasFullHeightSidebar,
                })}
                {...(hasFullHeightSidebar ? {} : attributes)}
            >
                {children}
            </div>
        </PageContainer>
    );
}
